import type { FaireProductEntity } from "../../entity_types/product";

export const p_6uwc539uqe: FaireProductEntity = {
  token: "p_6uwc539uqe",
  type: "product",
  name: "Juniper Cocktail / Nick & Nora Glass / Set of 2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/66b30daf6f4fb95dc755f153e3b56468b9c62ee1e270507e3d77112ddbd35e5a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c0fae228966944c5a5bdd407d9ae7ea3a761f843c274846820c3650f569bad66.jpeg",
    "https://cdn.faire.com/fastly/dd724bbbe1b79c6c7b4abda8fabb643735fa3db354714e1a10151dadd2ff9c6c.jpeg",
    "https://cdn.faire.com/fastly/9acfb5a7ac9070b9cb32a70816801d457c3bfa499669dc2a334b43cd7911bfd2.jpeg",
  ],
  priceDollars: 26.25,
  description:
    'Juniper is a sculptural glassware range designed to elevate the drinking experience by enhancing both flavour and aroma. The glasses are graphic in form yet functional and satisfying to use, and their striking geometric silhouette adds interest to any table, bar or drinks trolley.\n\nJuniper Cocktail Glass\n• Size: Ø 8 x H 15.3 cm / Ø 3.2" x H 6"\n• Capacity: 150 ml / 5 fl oz\n• Packed as a set of 2\n• Colour: clear',
  tags: [],
  msrpDollars: 52.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:21.549Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
